import { text } from './input.readonly.style.js';
import { jsx } from 'react/jsx-runtime';

function InTableReadonlyInput(props) {
  const content = (() => {
    let base = props.input.text;
    if (props.input.style.bold) {
      base = /*#__PURE__*/jsx("b", {
        children: base
      });
    }
    if (props.input.style.italic) {
      base = /*#__PURE__*/jsx("em", {
        children: base
      });
    }
    return base;
  })();
  return /*#__PURE__*/jsx("span", {
    className: text,
    "data-alignment": props.input.style.align,
    children: content
  });
}

export { InTableReadonlyInput };
//# sourceMappingURL=input.readonly.js.map
